export default __webpack_public_path__ + "36fb513c2049640ec6881ce4f154d00a.svg";